module.exports = __webpack_public_path__ + "img/744c721.jpg";